package com.eladfinish.bible.contest.features.verseWidget

import com.eladfinish.bible.contest.analytics.AnalyticsConstants.VerseWidget.Prompt
import com.eladfinish.bible.contest.analytics.providers.AnalyticsProvider

/** The events of the hint on the random-verse screen that offers the widget (docs/analytics/verse-widget.md). */
class VerseWidgetPromptReporter(
    private val analyticsProvider: AnalyticsProvider,
) {

    fun onShown(shownCount: Int, versesViewed: Int) {
        analyticsProvider.logEvent(
            Prompt.EVENT_SHOWN,
            mapOf(Prompt.PARAM_SHOWN_COUNT to shownCount, Prompt.PARAM_VERSES_VIEWED to versesViewed),
        )
    }

    /** The x was tapped. */
    fun onDismissed(shownCount: Int) {
        analyticsProvider.logEvent(Prompt.EVENT_DISMISSED, mapOf(Prompt.PARAM_SHOWN_COUNT to shownCount))
    }

    /** The hint itself was tapped, which opens the widget screen. */
    fun onCta(shownCount: Int) {
        analyticsProvider.logEvent(Prompt.EVENT_CTA, mapOf(Prompt.PARAM_SHOWN_COUNT to shownCount))
    }
}
